import { render } from "./Claim3.vue?vue&type=template&id=6575aa8c&scoped=true"
import script from "./Claim3.vue?vue&type=script&lang=js"
export * from "./Claim3.vue?vue&type=script&lang=js"

import "./Claim3.vue?vue&type=style&index=0&id=6575aa8c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6575aa8c"

export default script